<span
  *ngLet="{
    avatarState: avatarState | async,
    sizeClass: sizeClass | async,
    fallbackVariantClass: fallbackVariantClass | async,
    initials: initials | async
  } as vm"
  [ngClass]="[
    'avatar',
    vm.sizeClass || '',
    vm.fallbackVariantClass || '',
    vm.avatarState?.userTypeClass || ''
  ]"
  [ngStyle]="{
    'width.px': vm.avatarState?.size,
    'height.px': vm.avatarState?.size,
    'background-image': vm.avatarState?.imageUrl
  }"
>
  <ng-container *ngIf="!vm.avatarState?.imageUrl">
    {{ vm.initials || '\u00a0' }}
  </ng-container>
</span>
